import React from 'react';
import PropTypes from 'prop-types';
import styles from './OrderHistoryList.scss';
import ChevronRight from 'wix-ui-icons-common/ChevronRight';
import { translate } from 'react-i18next';
import { DeliveryTypes } from '../../utils/constants';
import { Text } from 'wix-style-react';

function getDeliveryTypeString(deliveryType, t) {
  if (deliveryType === DeliveryTypes.DELIVERY) {
    return t('phoneordering_menu_orderhistory_ordertype_delivery');
  } else if (deliveryType === DeliveryTypes.TAKEOUT) {
    return t('phoneordering_menu_orderhistory_ordertype_pickup');
  }
}

function OrderHistoryListItemContent(props) {
  const { order, t } = props;
  const Separator = () => (
    <React.Fragment>
      <span>&nbsp;&nbsp;</span>/<span>&nbsp;&nbsp;</span>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <div className={styles.details} data-hook={`order-history-list-item-wrapper-${order.id}`}>
        <Text
          size="medium"
          weight="normal"
          tagName="div"
          className={styles.title}
          data-hook="order-history-list-item-title"
        >
          {order.cart.items.map((item) => item.title).join(', ')}
        </Text>
        <Text size="small" weight="normal" secondary data-hook="order-history-list-item-description">
          {new Date(order.created).toDateString()}
          <Separator />
          {getDeliveryTypeString(order.deliveryType, t)}
          <Separator />
          {order.cart.summary.total.text}
        </Text>
      </div>
      <div className={styles.icon} data-hook="order-history-list-item-arrow">
        <ChevronRight className={styles.chevron} size={30} />
      </div>
    </React.Fragment>
  );
}

function OrderHistoryList({ displayableOrders, onOrderClick, t }) {
  const Divider = (props) => <div className={styles.divider}>{props.children}</div>;

  const items = displayableOrders.map((order, index) => {
    return (
      <div
        key={index}
        data-hook="order-history-list-item"
        className={styles.line}
        onClick={() => onOrderClick({ orderIndex: index })}
      >
        {index === displayableOrders.length - 1 ? (
          <OrderHistoryListItemContent order={order} t={t} />
        ) : (
          <Divider>
            <OrderHistoryListItemContent order={order} t={t} />
          </Divider>
        )}
      </div>
    );
  });

  return (
    <div className={styles.orderHistoryWrapper} data-hook="order-history-wrapper">
      {items}
    </div>
  );
}

OrderHistoryList.propTypes = {
  displayableOrders: PropTypes.array,
  onOrderClick: PropTypes.func,
  t: PropTypes.func,
};

OrderHistoryList.defaultProps = {
  displayableOrders: [],
};

export default translate()(OrderHistoryList);
